import { DanceStyleInterface, DanceStyleStatusEnum } from '../../..';

export class DanceStyleDto implements DanceStyleInterface {
  id: string;
  translationKey: string;
  danceStyleStatus: DanceStyleStatusEnum;
  isPairDance: boolean;
}
